import { Component, Input } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { AppliedConditions } from "@edp-models/benefits.model";
import { MultiCode } from "../code-generation.model";

@Component({
    selector: "code-generation-multi-codes",
    templateUrl: "./code-generation-multi-codes.component.html",
    styleUrls: ["./code-generation-multi-codes.component.scss"]
})
export class EdpECodeGenerationMultiCodesComponent {

    @Input() public multiCodes: MultiCode[];
    @Input() public appliedConditions: AppliedConditions;

    constructor(
        private readonly edpModalService: EdpModalService) { }

    public close() {
        this.edpModalService.close();
    }
}
